module.exports = __webpack_public_path__ + "static/media/unselectedDraw.d308fe4f.png";